import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { ChatLeftDots, Check2, CheckCircleFill, Whatsapp } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { sendInvoice } from "../Redux/Action/order.action";

const SocialShare = ({ orderData, handleClosePopup }) => {
  const { extensionData } = useSelector((state) => state.extensionReducer);
  const dispatch = useDispatch();
  const [whatsappExtension, setWhatsappExtension] = useState(false);
  const [copied, setCopied] = useState(false);
  const [checkMsg, setCheckMsg] = useState({
    whatsapp: false,
    msg: false,
  });
  const handleCopy = (link) => {
    navigator.clipboard.writeText(link);
    setCopied(true);
  };
  useEffect(() => {
    if (extensionData.length > 0) {
      const whatsappExtension = extensionData.find(
        (ext) => ext.extension_slug_name === "whatsapp-messanger",
      );
      setWhatsappExtension(whatsappExtension?.data ? true : false);
    }
  }, [extensionData]);
  const [isHovered, setIsHovered] = useState();
  return (
    <div className="p-5 sm:min-w-[460px] flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h4>Share Invoice</h4>
      </div>
      <hr className="main-border-color" />
      <div>
        <div className="flex flex-wrap items-center justify-center gap-4">
          {whatsappExtension && (
            <>
              <div
                className="flex items-center justify-center cursor-pointer bg-[#25d366] rounded-full h-16 w-16"
                onClick={() => {
                  setCheckMsg({ ...checkMsg, whatsapp: !checkMsg?.whatsapp });
                  dispatch(sendInvoice(orderData?._id, "whatsapp"));
                  handleClosePopup();
                }}
              >
                {!checkMsg?.whatsapp ? (
                  <Whatsapp className="h-8 w-8 text-white" />
                ) : (
                  <Check2 className="h-8 w-8 text-white" />
                )}
              </div>
            </>
          )}
          <div
            className="flex items-center justify-center cursor-pointer bg-gray-400 rounded-full h-16 w-16"
            onClick={() => {
              setCheckMsg({ ...checkMsg, msg: !checkMsg?.msg });
              dispatch(sendInvoice(orderData?._id, "sms"));
              handleClosePopup();
            }}
          >
            {!checkMsg?.msg ? (
              <ChatLeftDots className="h-8 w-8 text-white" />
            ) : (
              <Check2 className="h-8 w-8 text-white" />
            )}
          </div>
        </div>
        <div className="relative input mt-2">
          <input type="text" className="input-secondary" value={orderData?.invoice} readOnly />
          {copied === false ? (
            <Tooltip title="Copy" arrow>
              <button
                onMouseEnter={(e) => setIsHovered("copy")}
                onMouseLeave={(e) => setIsHovered("")}
                className="input-icon w-5 h-5 transition-all duration-300"
                onClick={(e) => {
                  e.preventDefault();
                  handleCopy(orderData?.invoice);
                }}
              >
                <svg
                  width={18}
                  height={18}
                  fill="currentcolor"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32 32"
                  id="copy"
                >
                  <path d="M28,10H12a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,28V12H28V28Z"></path>
                  <path d="M7,20H4V4H20V7a1,1,0,0,0,2,0V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H7a1,1,0,0,0,0-2Z"></path>
                </svg>
              </button>
            </Tooltip>
          ) : (
            <CheckCircleFill className="input-icon w-5 h-5" strokeWidth={1.5} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SocialShare;
